import * as React from 'react';
const SVGComponent = (props) => (
  <svg
    width={18}
    height={18}
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12.25 3.063H8.167a.44.44 0 0 1-.438-.438.44.44 0 0 1 .438-.437h4.083a.44.44 0 0 1 .438.437.44.44 0 0 1-.438.438m0 2.917H8.167a.44.44 0 0 1-.438-.438.44.44 0 0 1 .438-.438h4.083a.44.44 0 0 1 .438.438.44.44 0 0 1-.438.437m0 2.917H1.75a.44.44 0 0 1-.437-.438.44.44 0 0 1 .437-.437h10.5a.44.44 0 0 1 .438.437.44.44 0 0 1-.438.438m0 2.917H1.75a.44.44 0 0 1-.437-.438.44.44 0 0 1 .437-.437h10.5a.44.44 0 0 1 .438.437.44.44 0 0 1-.438.438M4.62 6.27H2.963c-.898 0-1.359-.454-1.359-1.358V3.255c0-.898.455-1.36 1.36-1.36h1.662c.898 0 1.359.456 1.359 1.36v1.663c-.006.898-.46 1.353-1.365 1.353m-1.657-3.5c-.414 0-.484.07-.484.485v1.663c0 .414.07.484.484.484h1.663c.414 0 .484-.07.484-.484V3.255c0-.414-.07-.484-.484-.484z'
      fill={props.color || 'white'}
    />
  </svg>
);
export default SVGComponent;
